import React from 'react';
import _get from 'lodash/get';
import useAnalytics from 'helpers/useAnalytics';
import { useHistory } from 'react-router';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import SearchIcon from '@material-ui/icons/Search';
import { GridToolbarContainer } from '@material-ui/data-grid';

import { HOME_URL, WIDGETS_URL } from 'components/Router/consts';

const CustomToolbar = (props: any) => {
  const classes = useStyles();
  const history = useHistory();
  const analytics = useAnalytics();
  const filterModel = _get(props, 'state.filter.items', []);
  const activeFilters =
    filterModel.length > 0
      ? filterModel.filter(
          (item: { value?: any }) =>
            item.value !== null && _get(item, 'value', '').toString() !== '',
        )
      : [];
  const counter = activeFilters.length;
  const { open } = props.state.preferencePanel;
  const { hideFilterPanel, showFilterPanel } = props.api.current;

  const toggleFilterPanel = () => {
    if (open) {
      hideFilterPanel();
    } else {
      showFilterPanel();
    }
  };

  const handleClick = () => {
    analytics.track('Create a widget clicked', {
      category: 'AD - Homepage',
    });

    history.push(`${HOME_URL}${WIDGETS_URL}/create/types`);
  };

  return (
    <GridToolbarContainer className={classes.actionBar}>
      <Button
        aria-label="search"
        color="secondary"
        onClick={toggleFilterPanel}
        startIcon={
          <Badge badgeContent={counter} color="secondary">
            <SearchIcon color="secondary" />
          </Badge>
        }
      >
        Search
      </Button>
      <Button variant="contained" color="secondary" disableElevation onClick={handleClick}>
        {props.buttonText}
      </Button>
    </GridToolbarContainer>
  );
};

const useStyles = makeStyles(theme => ({
  actionBar: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 2, 1, 1),
  },
}));

export default CustomToolbar;
